export class AssignmentQueuePageRequest {

    searchValue: string;
    pageNum: number;
    pageSize: number;
    sortBy: string;
    sortDir: string;
    providerId:string;
    scheduledDate:string;

}